import React from "react";
import { motion } from "framer-motion";
import YachtList from "../YachtList/YachtList"; // Assuming YachtList component exists or will be created

const Categories = () => {
  return (
    <section className="py-10" id="yacht-categories"> {/* Added ID for potential navigation */}
      <div className="items-center mx-auto container">
        <motion.h3
          className="text-3xl text-center font-medium mb-4 w-full lg:w-2/3 mx-auto JosefinSans tracking-wide px-4"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Explore Our Exquisite Fleet of Yachts <br /> for Your <b>Mykonos Yacht Charter</b>
        </motion.h3>
        <motion.hr
          className="w-40 mb-4 mx-auto border-2 border-red-400"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        />
        <motion.p
          className="text-center text-sm text-gray-400 mb-6 w-full lg:w-2/3 mx-auto JosefinSans tracking-wide px-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
    <b>Seascape Experiences</b> is a yacht charter company based in Mykonos, born to share our passion for the sea by delivering personalized yachting experiences to our guests.        </motion.p>
      </div>
      <motion.div
        className="mx-auto container"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <YachtList />
      </motion.div>
    </section>
  );
};

export default Categories;
